import { useEffect } from "react"

function useUpdatePageTitle(pageTitle: string) {
    useEffect(() => {
        document.title = pageTitle
    })
}

export default useUpdatePageTitle
